module.exports = __webpack_public_path__ + "static/media/6_School of the animals_DE.2c53d2ae.txt";